import { QuoteCarrierHeader } from '../components/quote';
import ValidationsSummary from 'views/validated_policy/components/ValidationsSummary';
import type { PropertyValidationsData } from 'api';

interface PropertyValidationsStepProps {
  data: PropertyValidationsData;
  validations: Validation[];
}

const PropertyValidationsStep = ({
  data,
  validations,
}: PropertyValidationsStepProps) => {
  if (!data.selected_carrier) {
    return null;
  }

  return (
    <>
      <QuoteCarrierHeader
        carrierName={data.selected_carrier.carrier_name}
        quoteRef={data.selected_carrier.acturis_quote_ref}
      />

      {validations.length > 0 && (
        <ValidationsSummary validations={validations} />
      )}
    </>
  );
};

export default PropertyValidationsStep;
